import { render, staticRenderFns } from "./GiftVendorList.vue?vue&type=template&id=599fe798&scoped=true&"
import script from "./GiftVendorList.vue?vue&type=script&lang=js&"
export * from "./GiftVendorList.vue?vue&type=script&lang=js&"
import style0 from "./GiftVendorList.vue?vue&type=style&index=0&id=599fe798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599fe798",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('599fe798')) {
      api.createRecord('599fe798', component.options)
    } else {
      api.reload('599fe798', component.options)
    }
    module.hot.accept("./GiftVendorList.vue?vue&type=template&id=599fe798&scoped=true&", function () {
      api.rerender('599fe798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/GiftVendorList.vue"
export default component.exports